import React, { useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import imgAzure from "../../assets/Microsoft.svg";
import "../../css/partner.css";
import { useTranslation } from "react-i18next";
import { ourPartners } from "../../config/ourPartners/textPage";
import { ActualLangContext } from "../../contexts/ActualLangContext";

const Partners = () => {
  const { t } = useTranslation();
  const { actualLang } = useContext(ActualLangContext);
  const microsoftEcosystemPath = actualLang === "es" ? "/es/microsoft-ecosystem" : "/en/microsoft-ecosystem";

  return (
    <Container fluid className="containerPartners">
      <Row className="justify-content-md-center" id="">
        <Col lg={12}>
          <h2 className="mt-4 textProviderHome">
            {t("ourPartners.title", {
              title: `${ourPartners.title}`,
            })}
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center align-items-center d-flex">
        <Col
          lg={4}
          xl={4}
          xxl={4}
          sm={12}
          className="justify-content-center align-items-center d-flex separatorImageLogoMobile containerImagePartners"
        >
          <Link to={microsoftEcosystemPath} aria-label="Microsoft Partner">
            <img src={imgAzure} className="img-fluid mr-1" alt="Azure" loading="lazy" />
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export default Partners;
